import React from 'react';

import { Box, Flex, Icon, Text } from 'core/components';
import { deviceSubTypeIconMap } from 'app/components/device/DeviceSubtypeIcon';

interface DeviceNameOptionsLabelProps {
  device: { device_name: string; device_subtype?: string; id?: string | number };
  showId?: boolean;
}

const DeviceNameOptionsLabel = ({ device, showId }: DeviceNameOptionsLabelProps) => {
  const { device_name, device_subtype, id } = device;
  return (
    <Flex alignItems="center">
      <Icon icon={device_subtype ? deviceSubTypeIconMap[device_subtype] : undefined} color="muted" mr="4px" />
      <Box flex={1}>{device_name}</Box>
      {showId && (
        <Text muted small ml={1}>
          {id}
        </Text>
      )}
    </Flex>
  );
};

export default DeviceNameOptionsLabel;
